
import { DateGregAndHijriDisp } from "@/models/BuilderModels/DateGregAndHijri";
import ValidationService from "@/services/ValidationService";
import SharedService from "@/shared/userService/SharedService";
import { Inject } from "vue-di-container";

import { Component, Prop, PropSync, Vue, Watch } from "vue-property-decorator";
import { string } from "Yup";

var moment = require("moment-hijri");
@Component({
  directives: {},
  components: {},
  diProvide: [ValidationService, SharedService],
})
export default class DateListViewer extends Vue {
  @Prop({ default: "" })
  currentDate!: string;

  @Prop({ default: undefined })
  dateDisplay!: DateGregAndHijriDisp;

  @Inject(ValidationService) public validationService!: ValidationService;
  @Inject(SharedService) public sharedService!: SharedService;

  hijriDate: string | undefined = "";
  miladiDate: string = "";

  public mounted() {
    if (this.dateDisplay == undefined) {
      this.hijriDate =
        this.sharedService.getFormatedDate(this.currentDate) + "هـ";

      if (this.hijriDate.length > 0) {
        let m = moment(
          this.currentDate,
          this.validationService.getDateFormate(this.currentDate)
        );

        this.miladiDate = m.locale("en").format("YYYY/MM/DD") + "م";
      }
    } else {
      this.hijriDate =  this.dateDisplay.hijriDate + " هـ";
      this.miladiDate = this.dateDisplay.gregDateDisp + " م ";
    }
  }
}
